export default __webpack_public_path__ + "static/media/480_private03-fr-mobile.9ab77ffd.png";